import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UpdateSubscriptionTypePermissions } from '@dto/updateSubscriptionTypePermissions';
import { Subscription } from '@models/subscription';
import { SubscriptionTypePermission } from '@models/subscriptionTypePermission';
import { Observable } from 'rxjs';
import { EntityService } from './entity.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService extends EntityService {

  public entityRoute = "subscriptions";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  getSubscriptionTypePermissions(typeId: number): Observable<SubscriptionTypePermission[]> {
    return this.http.get<SubscriptionTypePermission[]>(this.baseUrl + 'api/subscriptions/type/' + typeId + '/permissions');
  }

  async getSubscriptionTypePermissionsAsync(typeId: number): Promise<SubscriptionTypePermission[]> {
    return await this.http.get<SubscriptionTypePermission[]>(this.baseUrl + 'api/subscriptions/type/' + typeId + '/permissions').toPromise();
  }

  updateSubscriptionTypePermissions(typeId: number, subscriptionTypePermissions: SubscriptionTypePermission[]): Observable<SubscriptionTypePermission[]> {
    return this.http.put<SubscriptionTypePermission[]>(this.baseUrl + 'api/subscriptions/type/' + typeId + '/permissions', subscriptionTypePermissions);
  }

  updateAllSubscriptionTypePermissions(body: UpdateSubscriptionTypePermissions): Observable<SubscriptionTypePermission[]> {
    return this.http.put<SubscriptionTypePermission[]>(this.baseUrl + 'api/subscriptions/type/all/permissions', body);
  }

  matches(subscription: Subscription, term: string) {
    return subscription.id.toString().includes(term.toLowerCase());
  }
}
